import { render, staticRenderFns } from "./Rappel.vue?vue&type=template&id=db661a80&scoped=true"
import script from "./Rappel.vue?vue&type=script&lang=js"
export * from "./Rappel.vue?vue&type=script&lang=js"
import style0 from "./Rappel.vue?vue&type=style&index=0&id=db661a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db661a80",
  null
  
)

export default component.exports